import { GetFormalOffersResponse } from '@iwoca/lapi-client/edge';
import { Radio } from '@iwoca/orion';
import { isInterestOnly } from '../../../../myOffers/MyOffers.helpers';
import messages from './selectOfferType.messages';
import { FormattedMessage, useIntl } from 'react-intl';

type FormalOffers = NonNullable<
    GetFormalOffersResponse['data']
>['formal_offers'];

export const SelectOfferType = ({
    formalOffers,
    setOfferChoices,
    drawdownAmount
}: {
    formalOffers: FormalOffers;
    setOfferChoices: (formalOffers: FormalOffers) => void;
    drawdownAmount: number;
}) => {
    const intl = useIntl();

    const flexibleOffers = formalOffers.filter(
        (offer) => offer.duration!.amount! <= 730 && !isInterestOnly(offer)
    );

    const longerDurationOffers = formalOffers.filter(
        (offer) => offer.duration!.amount! > 730
    );

    const interestOnlyOffers = formalOffers.filter((offer) =>
        isInterestOnly(offer)
    );

    const isDrawdownAmountInRange = (offers: FormalOffers) => {
        return offers.every((offer) => drawdownAmount > offer.available_cash!);
    };

    if (interestOnlyOffers.length > 0) {
        return (
            <>
                <p className="text-m font-bold">
                    <FormattedMessage
                        {...messages.interstOnlyOfferTypeHeading}
                    />
                </p>

                <div className="flex flex-col gap-m">
                    <Radio
                        frame
                        id="flexible-loans-offers"
                        label={
                            (
                                <p className="w-10/12 font-light">
                                    <FormattedMessage
                                        tagName="span"
                                        {...messages.flexibleLoansTitle_withIOoption}
                                        values={{
                                            strong: (chunks) => (
                                                <strong>{chunks}</strong>
                                            )
                                        }}
                                    />
                                </p>
                            ) as unknown as string
                        }
                        name="offer-selection-buttons"
                        onChange={() => setOfferChoices(flexibleOffers)}
                        disabled={isDrawdownAmountInRange(flexibleOffers)}
                    />
                    <Radio
                        frame
                        id="interest-only-loans-offers"
                        label={
                            (
                                <p className="w-10/12 font-light">
                                    <FormattedMessage
                                        tagName="span"
                                        {...messages.interestOnlyLoansTitle}
                                        values={{
                                            strong: (chunks) => (
                                                <strong>{chunks}</strong>
                                            )
                                        }}
                                    />
                                </p>
                            ) as unknown as string
                        }
                        name="offer-selection-buttons"
                        onChange={() => setOfferChoices(interestOnlyOffers)}
                        disabled={isDrawdownAmountInRange(interestOnlyOffers)}
                    />
                </div>
            </>
        );
    }

    return (
        <>
            <p className="text-m font-bold">
                {intl.formatMessage(messages.longerLoansOfferTypeHeading)}
            </p>

            <div className="flex flex-col gap-m">
                <Radio
                    frame
                    id="flexible-loans-offers"
                    label={
                        (
                            <p className="w-10/12 font-light">
                                <FormattedMessage
                                    tagName="span"
                                    {...messages.flexibleLoansTitle}
                                    values={{
                                        strong: (chunks) => (
                                            <strong>{chunks}</strong>
                                        )
                                    }}
                                />
                            </p>
                        ) as unknown as string
                    }
                    name="offer-selection-buttons"
                    onChange={() => setOfferChoices(flexibleOffers)}
                    disabled={isDrawdownAmountInRange(flexibleOffers)}
                />

                <Radio
                    frame
                    id="longer-loans-offers"
                    label={
                        (
                            <p className="w-10/12 font-thin">
                                <FormattedMessage
                                    tagName="span"
                                    {...messages.longerLoansTitle}
                                    values={{
                                        strong: (chunks) => (
                                            <strong>{chunks}</strong>
                                        )
                                    }}
                                />
                            </p>
                        ) as unknown as string
                    }
                    name="offer-selection-buttons"
                    onChange={() => setOfferChoices(longerDurationOffers)}
                    disabled={isDrawdownAmountInRange(longerDurationOffers)}
                />
            </div>
        </>
    );
};
